import EL, { HTMLELEMENT } from '../../../../EL/EL.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
// Model Structure
export const fieldAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['style']
]);
export const fieldData = makeDataStruct([]);
export const fieldModel = makeStruct([
    ['attributes', fieldAttr],
    ['data', fieldData]
]);
// Class
export default class FIELD extends EL {
    constructor(node, element, model) {
        super(node, element, model);
    }
    /** Return the name of this field */
    getName() {
        return this.getAttribute('name') || '';
    }
    getFormField() {
        return this.node || null;
    }
}
export { EL, HTMLELEMENT };
